import React from 'react';
import T from 'prop-types';
import { isEmpty } from 'lodash-es';

import CompanyKpiForecasts from './CompanyKpiForecastsQV';
import CompanyMpiSpotlight from './CompanyMpiSpotlightQV';
import CompanyKpiSpotlight from './CompanyKpiSpotlightQV';
import ErrorStateWithReload from '../../../../../ErrorStateWithReload';

const emptyObject = {};

const KpiSpotlightQV = ({ settings, company, data = emptyObject }) => {
  if (settings.error) {
    return <ErrorStateWithReload />;
  }

  if (isEmpty(data.mpi_spotlight) && data.forecasts) {
    return <CompanyKpiForecasts forecasts={data.forecasts} company={company} />;
  }

  if (data.mpi_spotlight) {
    return (
      <CompanyMpiSpotlight
        kpiSpotlight={data.mpi_spotlight}
        company={company}
        settings={settings}
      />
    );
  }

  if (data.spotlights || settings.pending) {
    return <CompanyKpiSpotlight kpiSpotlight={data.spotlights} settings={settings} />;
  }

  return null;
};

KpiSpotlightQV.propTypes = {
  settings: T.shape({
    error: T.bool,
    pending: T.bool,
  }).isRequired,
  company: T.object.isRequired,
  data: T.shape({
    forecasts: T.array,
    spotlights: T.array,
  }),
};

export default KpiSpotlightQV;
